import { QueryClient } from '@tanstack/react-query';

export const isAuthError = (err: unknown): boolean => {
  if (!err) return false;

  if (err instanceof Response) {
    return err.status === 401;
  }

  if (typeof err === 'object' && err !== null) {
    const maybeStatus = (err as { status?: number; response?: { status?: number } });
    if (maybeStatus.status === 401 || maybeStatus.response?.status === 401) {
      return true;
    }
  }

  const message = (err as { message?: string })?.message?.toLowerCase?.() ?? '';
  return message.includes('401') || message.includes('invalid token');
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (isAuthError(error)) return false;
        return failureCount < 1;
      },
    },
  },
});
